module.exports = __webpack_public_path__ + "img/logo-min.1aa664d9.svg";